import { render, staticRenderFns } from "./MainMenuSection.vue?vue&type=template&id=25b47b6a&scoped=true&"
import script from "./MainMenuSection.vue?vue&type=script&lang=js&"
export * from "./MainMenuSection.vue?vue&type=script&lang=js&"
import style0 from "./MainMenuSection.vue?vue&type=style&index=0&id=25b47b6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b47b6a",
  null
  
)

export default component.exports